<footer>
  <div [@animateFooter] class="row mx-0 py-2 d-flex justify-content-center align-items-center">
    <label class="mb-0 fs-12">© {{ currentYear }} Copyright - Annevanilla</label>
  </div>
</footer>
